import { lockScroll, unlockScroll } from 'JS/utils/lock-screen';

class FullscreenLoader {
    /**
     * @type {HTMLElement}
     */
    element;

    activeClass = 'fullscreen-loader--active';

    _active = false;

    get active() {
        return this._active;
    }

    set active(value) {
        this._active = value;
        this.onChange();
    }

    constructor(element) {
        this.element = element;
    }

    onChange() {
        if (this.active) {
            this.element.classList.add(this.activeClass);
            lockScroll();
        } else {
            this.element.classList.remove(this.activeClass);
            unlockScroll();
        }
    }

    hideWithoutUnlock() {
        this._active = false;
        this.element.classList.remove(this.activeClass);
    }
}

(() => {
    const loaderElement = document.querySelector('#fullscreen-loader');
    window.fullscreenLoader = new FullscreenLoader(loaderElement);
})();
